import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class AgentRequirementsProgressListCtrl implements IController {

  selectRequirement: any;
  requirements: any;

  private requirementCompletedCount: any;
  private requirementsProgress: any;

  constructor() {
  }

  $onInit() {
    this.requirementCompletedCount = 0;
  }

  $onChanges(changes) {
    if (changes.requirements) {
      this.recalcRequirementProgress();
    }
  }

  recalcRequirementProgress() {
    let counter = 0;
    _.forEach(this.requirements, function(requirement) {
      if (_.isEqual(requirement.status, 'Approved')) {
        counter++;
      }
    });
    const requirementsProgressPercentage = (counter / _.get(this.requirements, 'length', 0)) * 100;
    this.requirementsProgress = {
      'width' : requirementsProgressPercentage + '%'
    };
    this.requirementCompletedCount = counter;
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentRequirementsProgressList', {
    bindings: {
      selectRequirement: '<',
      requirements: '<'
    },
    template: require('./agent-requirements-progress-list.html').default,
    controller: AgentRequirementsProgressListCtrl
  });
